module.exports = __webpack_public_path__ + "static/media/PLAYER4-TAG.d4b97dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER4-TAG.png
// module id = 268
// module chunks = 0